import cls from "classnames";
import React from "react";
import { ImageUpload } from "../../image-upload/image-upload.js";
import { TextField } from "../../text-field/text-field.js";
import { PollOptionBase } from "../poll-option-base.js";
import styles from "./option-webview-scss.js";
class PollListOptionWebview extends PollOptionBase {
  render() {
    const { option, dark, t } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles.option, styles.list, {
          [styles.with_image]: this.isImageEnabled() && option.image.src.url,
          [styles.dark]: dark
        })
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          maxLength: 60,
          className: cls(styles.input),
          value: option.title,
          placeholder: t("Poll_Editor_Answer_Placeholder"),
          startAdornment: /* @__PURE__ */ React.createElement(ImageUpload, { className: styles.image, value: option.image.src.url, small: true })
        }
      ))
    );
  }
}
PollListOptionWebview.propTypes = PollOptionBase.propTypes;
export {
  PollListOptionWebview
};
//# sourceMappingURL=poll-list-option-webview.js.map
